const toHex = (n) => {
  const hex = n.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
};

/**
 * Adjusts a hex color by lightening or darkening it by a given percentage
 * @param {string} hex - The hex color value (e.g., "#FF5733" or "FF5733")
 * @param {number} percent - The percentage to adjust (-100 to 100)
 *                          Positive values lighten, negative values darken
 * @returns {string} The adjusted hex color
 */
function adjustHexColor(hex = "", percent) {
  if (!hex.match(/^#/)) {
    return hex;
  }

  // Remove the hash if present
  if (!hex.match(/^#/)) {
    return hex;
  }

  hex = hex.replace(/^#/, "");

  // Convert 3-digit hex to 6-digit
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  // Validate hex format
  if (!/^[0-9A-F]{6}$/i.test(hex)) {
    throw new Error("Invalid hex color format");
  }

  // Ensure percent is within valid range
  percent = Math.max(-100, Math.min(100, percent));

  // Convert hex to RGB
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  // Calculate the adjustment amount
  const amount = Math.abs(percent) / 100;

  let newR, newG, newB;

  if (percent > 0) {
    // Lighten: move towards white (255)
    newR = Math.round(r + (255 - r) * amount);
    newG = Math.round(g + (255 - g) * amount);
    newB = Math.round(b + (255 - b) * amount);
  } else {
    // Darken: move towards black (0)
    newR = Math.round(r * (1 - amount));
    newG = Math.round(g * (1 - amount));
    newB = Math.round(b * (1 - amount));
  }

  return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
}

export default adjustHexColor;
